import React, { Component } from 'react';
import { Button, Form, Input } from 'components/antd';
import { PhoneInput, NameInput, NotificationByEmail } from 'components';
import DynamicFields from '../DynamicFields/DynamicFields';
import { CountriesData } from 'app-types';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import classNames from 'classnames';
import { PhoneInputData } from '../PhoneInput/PhoneInput';
import styles from './AlternativeContacts.module.scss';

interface Props {
	countriesDictionary: CountriesData[];
	form: WrappedFormUtils;
	maxRows?: number;
	initialValues?: Array<{ [key: string]: any }>;
	isNotificationByEmailVisible?: boolean;
}

export class AlternativeContacts extends Component<Props> {
	render() {
		const { form, maxRows, isNotificationByEmailVisible } = this.props;
		const { getFieldDecorator } = form;
		return (
			<DynamicFields
				validateFields={this.props.form.validateFields}
				listName="alternativeContactList"
				initialValues={this.props.initialValues}
				max={maxRows}
				render={props => {
					const {
						rowInitialNumber,
						getItemName,
						removeRow,
						rowName,
						getInitValue,
					} = props;
					return (
						<div key={`alternativeContact-${rowInitialNumber}`}>
							<div
								className={classNames('modalBoxRow', styles.alternativeContacts, {
									modalBoxRowWithPt: rowInitialNumber > 0,
								})}
							>
								<div className="modalBoxCol w4">
									<Form.Item label="Name" help={''} validateStatus={''}>
										<NameInput
											initialValue={getInitValue(['fullName'])}
											keyName={rowName}
											required={false}
											form={form}
										/>
									</Form.Item>
								</div>
								<div className="modalBoxCol w4">
									<Form.Item label="Phone" help={''} validateStatus={''}>
										<PhoneInput
											initialValue={
												getInitValue([
													'phoneCodeCountryId',
													'phoneNumber',
												]) as PhoneInputData
											}
											keyName={rowName}
											required={false}
											form={form}
											countries={this.props.countriesDictionary}
										/>
									</Form.Item>
								</div>
								<div
									className={classNames(
										'modalBoxCol',
										rowInitialNumber === 0 ? 'w4' : 'w3'
									)}
								>
									<Form.Item label="Email address" help={''} validateStatus={''}>
										{getFieldDecorator(getItemName('emailAddress'), {
											initialValue: getInitValue('emailAddress'),
											rules: [
												{
													whitespace: true,
													required: false,
												},
											],
										})(<Input />)}
									</Form.Item>
								</div>
								{rowInitialNumber !== 0 && (
									<div className="removeButtonCol">
										<Button
											icon="remove"
											size="large"
											onClick={() => removeRow(rowInitialNumber)}
										/>
									</div>
								)}
								{getFieldDecorator(getItemName('id'), {
									initialValue: getInitValue('id'),
									rules: [
										{
											whitespace: false,
											required: false,
											type: 'number',
										},
									],
								})(<Input type={'hidden'} />)}
								{getFieldDecorator(getItemName('customerId'), {
									initialValue: getInitValue('customerId'),
									rules: [
										{
											whitespace: false,
											required: false,
											type: 'number',
										},
									],
								})(<Input type={'hidden'} />)}
							</div>
							<div className="modalBoxDeviderSmall"></div>
							{isNotificationByEmailVisible && (
								<>
									<div className="modalBoxRow">
										<div className="modalBoxCol w12">
											<NotificationByEmail
												form={form}
												bookingConfirmationName={getItemName(
													'bookingConfirmation'
												)}
												bookingConfirmationData={
													(getInitValue(
														'bookingConfirmation'
													) as unknown) as boolean
												}
												invoiceConfirmationName={getItemName(
													'invoiceConfirmation'
												)}
												invoiceConfirmationData={
													(getInitValue(
														'invoiceConfirmation'
													) as unknown) as boolean
												}
												calendarBookingEventName={getItemName(
													'calendarBookingEvent'
												)}
												calendarBookingEventData={
													(getInitValue(
														'calendarBookingEvent'
													) as unknown) as boolean
												}
											/>
										</div>
									</div>
									<div className="modalBoxDeviderSmall" />
								</>
							)}
						</div>
					);
				}}
				renderAddButton={(add, disabled) => {
					return (
						<div>
							<Button type="dashed" onClick={add} disabled={disabled}>
								+ Add contact
							</Button>
						</div>
					);
				}}
			/>
		);
	}
}
